export type RegistrationFormData = {
	acceptTermsAndConditions: boolean;
	accountCreateAcceptance: boolean;
	playerPromoSendingMode: string;
	birthName?: string | null;
	birthPlace?: string | null;
	challengeResponse?: string | null;
	city: string;
	confirmPassword: string;
	countryId: string;
	cultureInfoName: string;
	dob: string;
	day?: string | null;
	month?: string | null;
	year?: string | null;
	email: string;
	firstName: string;
	houseNumber: string;
	lastName: string;
	limitAmount?: string | null;
	limitDurationId?: string | null;
	languageId?: string;
	mobilePhone?: string | null;
	nationality?: string | null;
	nationalityId?: string | null;
	occupationId: string;
	password: string;
	regionId: string;
	repeatEmail: string;
	street: string;
	titleId: string;
	userTitleId: string;
	username: string;
	zipCode: string;
	personalIdentificator?: string | null;
	estimatedGamingAmountId?: string;
};

export interface CreateUserDto {
	acceptTermsAndConditions: boolean;
	activationUrl: string;
	affiliateCode?: string | null;
	applicationIdentifier: string;
	birthName?: string | null;
	birthPlace?: string | null;
	challengeResponse: string;
	city: string;
	confirmPassword: string;
	countryId: string;
	cultureInfoName?: string | null;
	dob: string;
	email: string;
	estimatedGamingAmountId?: string | null;
	firstName: string;
	houseNumber: string;
	lastName: string;
	limitAmount?: string | null;
	limitDurationId?: string | null;
	languageId?: string;
	mobilePhone?: string | null;
	nationality?: string | null;
	nationalityId?: string | null;
	occupationId?: string | null;
	password: string;
	personalIdentificator?: string | null;
	partnerIdentificator?: string;
	playerPromoSendingMode: PlayerPromoSendingMode;
	regionId?: string | null;
	street: string;
	userTitleId: string;
	username: string;
	zipCode: string;
	titleId: string;
	isExternalProviderRegistration?: boolean;
}

export enum PlayerPromoSendingMode {
	Disabled = 0,
	Enabled = 1,
	Forbidden = 2,
}
